import ConfidenceFactorView from './ConfidenceFactorView';

export default ConfidenceFactorView;
